var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.requestManager.manager.anyPending)?_c('span',{staticClass:"wallet-currency"},[_vm._v(" "+_vm._s(_setup.shouldShowAvailable ? 'Available balance' : 'Balance')+": "),_c(_setup.WalletsFormattedCurrency,{attrs:{"currency":_vm.currency,"value":_setup.balance}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }